import axios from 'axios';

const API_ORIGIN =
  process.env.REACT_APP_API_BASE ||
  (['localhost', '127.0.0.1'].includes(window.location.hostname)
    ? 'http://localhost:3001'
    : '');

const normalizedApiOrigin = API_ORIGIN.replace(/\/$/, '');
const API_BASE = normalizedApiOrigin.endsWith('/api')
  ? normalizedApiOrigin
  : `${normalizedApiOrigin}/api`;

export async function fetchAteSwVersions() {
  const response = await axios.get(`${API_BASE}/ate-sw-versions`);
  return response.data;
}

export async function fetchTestspecs() {
  const response = await axios.get(`${API_BASE}/testspecs`);
  return response.data;
}

export async function fetchControlChartData(params = {}) {
  const response = await axios.get(`${API_BASE}/control-chart-data`, { params });
  return response.data;
}

export async function fetchControlChartStepNumbers(params = {}) {
  const response = await axios.get(`${API_BASE}/control-chart-step-numbers`, { params });
  return response.data;
}

export async function fetchFilenames() {
  const response = await axios.get(`${API_BASE}/filenames`);
  return response.data;
}

export async function calculateUclLcl({ selectedFileIds, stepNumber }) {
  const response = await axios.post(`${API_BASE}/calculate-ucl-lcl`, {
    selectedFileIds,
    stepNumber,
  });
  return response.data;
}
